import SvgArrowDownIcon from '@local/web-design-system-2/icons/ArrowDown';
import SvgArrowUpIcon from '@local/web-design-system-2/icons/ArrowUp';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { useCallback, useState } from 'react';

import { API_ENDPOINTS, getApiEndpoint, setApiEndpoint } from 'src/utils/api-endpoints';

import { useMenuItemStyles, useStyles } from './ApiSelector.styles';

export const ApiSelector = () => {
    const apiEndpoint = getApiEndpoint();

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const { classes } = useStyles();
    const { classes: menuItemClasses } = useMenuItemStyles();

    const handleToggle = useCallback(() => setIsDropdownOpen((prev) => !prev), []);

    const handleClose = useCallback(() => setIsDropdownOpen(false), []);

    const handleSetApiEndpoint = (key: keyof typeof API_ENDPOINTS) => {
        if (apiEndpoint.NAME === API_ENDPOINTS[key].NAME) {
            return;
        }

        setApiEndpoint(key);
    };

    return (
        <>
            <Button
                automation-id="api-selector-button"
                variant="contained"
                color="inherit"
                className={classes.button}
                onClick={handleToggle}
                ref={setAnchorEl}
                sx={{
                    color: apiEndpoint.COLOUR,
                    '& svg': {
                        marginLeft: '5px',
                    },
                }}
                aria-expanded={isDropdownOpen ? 'true' : undefined}
                aria-haspopup="true"
            >
                <span>
                    <b>API: {apiEndpoint.NAME}</b>
                </span>
                {isDropdownOpen ? <SvgArrowUpIcon /> : <SvgArrowDownIcon />}
            </Button>

            <Popper open={isDropdownOpen} anchorEl={anchorEl} placement="bottom-start">
                <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                        <MenuList>
                            {Object.entries(API_ENDPOINTS).map(([key, endpoint]) => (
                                <MenuItem
                                    key={key}
                                    classes={menuItemClasses}
                                    onClick={() => {
                                        handleSetApiEndpoint(key as keyof typeof API_ENDPOINTS);
                                        handleClose();
                                    }}
                                    sx={{
                                        color: endpoint.COLOUR,
                                    }}
                                >
                                    {key} ({endpoint.URL})
                                </MenuItem>
                            ))}
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popper>
        </>
    );
};
